import { render, staticRenderFns } from "./FileChatMessage.htm?vue&type=template&id=b8aaf34a&scoped=true&"
import script from "./FileChatMessage.ts?vue&type=script&lang=js&"
export * from "./FileChatMessage.ts?vue&type=script&lang=js&"
import style0 from "./FileChatMessage.scss?vue&type=style&index=0&id=b8aaf34a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8aaf34a",
  null
  
)

export default component.exports